module.exports = "<option value=\"{%- pageData %}\" {%- (pageData == pageSize) ? 'selected' : '' %}>{%- pageData %} per Page</option>";


//////////////////
// WEBPACK FOOTER
// ./src/components/pagableComponent/html/pageSelect.html
// module id = 1163
// module chunks = 1